<template>
    <div class="order-container dk-flex-column">
        <van-cell-group title="订单信息" :border="true">
            <van-cell
                    :title="productInfo.productName"
                    :value="'￥' + (amount / 100).toFixed(2)"
                    size="large"
                    value-class="item-value"
            ></van-cell>
            <van-cell
                    title=""
                    :value="'合计：￥' + (amount / 100).toFixed(2)"
                    value-class="total-value"
                    size="large"
            ></van-cell>
        </van-cell-group>

        <van-divider>{{ discountValue }}</van-divider>
        <van-notice-bar
                :text="tipsValue"
                left-icon="volume-o"
                style="margin-bottom: 20px"
        />
        <van-cell-group :border="true">
            <van-cell
                    title="优惠券"
                    :value="couponPrice ? couponPrice : couponValue"
                    :disabled="couponValue <= 0"
                    size="large"
                    value-class="item-value"
                    is-link
                    @click="onShowCouponClick"
            ></van-cell>
        </van-cell-group>

        <van-submit-bar
                :price="payAmount > -1 ? payAmount : parseInt(amount)"
                button-text="立即支付"
                label="应付"
                @submit="onPay"
                button-type="danger"
                safe-area-inset-bottom
        >
            <div class="dk-flex-row-center" slot="tip">
                请在
                <van-count-down
                        style="color: red; font-weight: bold; margin: 0 5px"
                        :time="time"
                        format="ss"
                        @finish="onOrderInvalid"
                />
                秒内完成支付，否则当前交易将会失效。
            </div>
        </van-submit-bar>

        <!-- 优惠券列表 -->
        <van-popup
                v-model="showCouponList"
                round
                closeable
                position="bottom"
                style="
        max-height: 50%;
        min-height: 40%;
        padding-top: 4px;
        background: #eee;
      "
        >
            <div class="dk-flex-column coupon-popup-container">
                <van-tabs style="height: 70%" v-model="tabActive">
                    <van-tab title="可用优惠券">
                        <div class="coupon-list-container dk-flex-column">
                            <div
                                    class="coupon-item"
                                    v-for="(item, index) in couponListCanUse"
                                    :key="index"
                                    @click.stop="onUserCoupon(item)"
                            >
                                <div class="main-container">
                                    <div class="left-container">
                                        <div>{{ getContent(item.couponType, item.money) }}</div>
                                        <div class="left-unit">
                                            {{ getContentTxt(item.couponType, item.money) }}
                                        </div>
                                    </div>
                                    <div class="line_vertical"></div>
                                    <div class="right-container">
                                        <div class="title-container">
                                            <div class="title">{{ item.couponName }}</div>
                                            <div class="data">有效期至:{{ item.useEnd }}</div>
                                        </div>
                                        <div class="coupon-type">{{ getCouponType(item) }}</div>
                                    </div>
                                </div>
                                <div
                                        class="introduction-tag"
                                        @click.stop="showCouponIntroduction(index, couponListCanUse)"
                                >
                  <span
                  >使用说明
                  </span>
                                    <div :class="[(item.showIntroduction ? item.showIntroduction : false)?'boxtop':'boxbottom']"></div>

                                    <!-- <img
                                       v-if="item.showIntroduction ? item.showIntroduction : false"
                                      src="@/assets/top.png"
                                      alt=""
                                    />
                                    <img v-else src="@/assets/bottom.png" alt="" /> -->
                                </div>
                                <div
                                        class="introduction-content"
                                        v-if="item.showIntroduction ? item.showIntroduction : false"
                                >
                                    {{ item.remark }}
                                </div>
                            </div>
                        </div>
                    </van-tab>
                    <van-tab title="不可用优惠券">
                        <div class="coupon-list-container dk-flex-column">
                            <div
                                    class="coupon-item"
                                    v-for="(item, index) in couponListNoUse"
                                    :key="index"
                            >
                                <!-- ---------------------------------------- -->

                                <div class="main-container">
                                    <div class="left-container">
                                        <div>{{ getContent(item.couponType, item.money) }}</div>
                                    </div>
                                    <div class="line_vertical"></div>
                                    <div class="right-container">
                                        <div class="title-container">
                                            <div class="data">有效期至:{{ item.useEnd }}</div>

                                            <div class="title">{{ item.couponName }}</div>
                                        </div>
                                        <div class="coupon-type">{{ getCouponType(item) }}</div>
                                    </div>
                                </div>
                                <div
                                        class="introduction-tag"
                                        @click.stop="showCouponIntroduction(index, couponListNoUse)"
                                >
                                    <span>使用说明</span>
                                    <div :class="[(item.showIntroduction ? item.showIntroduction : false)?'boxtop':'boxbottom']"></div>

                                    <!-- <img
                                      v-if="item.showIntroduction ? item.showIntroduction : false"
                                      src="@/assets/top.png"
                                      alt=""
                                    />
                                    <img v-else src="@/assets/bottom.png" alt="" /> -->
                                </div>

                                <div
                                        class="introduction-content"
                                        v-if="item.showIntroduction ? item.showIntroduction : false"
                                >
                                    {{ item.remark }}
                                </div>
                            </div>
                        </div>
                    </van-tab>
                </van-tabs>
<!--                <div class="dk-flex-row-center coupon-btn-container">-->
<!--                    <van-button-->
<!--                            type="danger"-->
<!--                            @click="onDiableCoupon"-->
<!--                            size="large"-->
<!--                            round-->
<!--                            style="width: 80%; background: #ffc204 !important; border: none"-->
<!--                    >-->
<!--                        不使用优惠券-->
<!--                    </van-button>-->
<!--                </div>-->
            </div>
        </van-popup>
    </div>
</template>

<script>
    // @ is an alias to /src
    import {CouponModel} from "../utils/couponModel";

    const couponModel = new CouponModel();
    import {
        Button,
        Cell,
        CellGroup,
        CouponCell,
        CouponList,
        Divider,
        Panel,
        Popup,
        SubmitBar,
        NoticeBar,
        Tab,
        Tabs,
        CountDown,
        Dialog,
    } from "vant";

    export default {
        name: "home",
        data() {
            return {
                productInfo: "",
                couponAmount: "", //优惠券金额
                showCouponList: false,
                facilityId: "",
                facilityCode: "",
                productId: "",
                commodityCode: "",
                qr_type: "",
                order_no: "",
                couponListCanUse: [],
                couponListNoUse: [],
                pageParams: "",
                code: "",
                redisKey: "",
                tabActive: 0,
                order: "",
                orderWithCoupon: "",
                payAmount: -1,
                amount: 0,
                auth: localStorage.getItem("token"),
                tipsValue: "欢迎使用新咖啡",
                discountValue: "使用优惠券，享受特价服务",
                time: 90 * 1000,
                couponPrice: null // 优惠金额 null 不显示
            };
        },
        computed: {
            // eslint-disable-next-line vue/return-in-computed-property
            couponValue: function () {
                // if (this.auth) {
                //     return "点击获取优惠券";
                // }
                var couponCanUseCount = 0;
                if (
                    this.couponListCanUse.length <= 0 &&
                    this.couponListNoUse.length <= 0
                ) {
                    couponCanUseCount = 0;
                } else {
                    couponCanUseCount = this.couponListCanUse.length;
                }
                return couponCanUseCount === 0
                    ? "无可用优惠券"
                    : couponCanUseCount + "张优惠券可用";
            },
        },
        components: {
            [Panel.name]: Panel,
            [CouponCell.name]: CouponCell,
            [CouponList.name]: CouponList,
            [Divider.name]: Divider,
            [Button.name]: Button,
            [Popup.name]: Popup,
            [SubmitBar.name]: SubmitBar,
            [Cell.name]: Cell,
            [CellGroup.name]: CellGroup,
            [Tab.name]: Tab,
            [Tabs.name]: Tabs,
            [NoticeBar.name]: NoticeBar,
            [CountDown.name]: CountDown,
            [Dialog.Component.name]: Dialog.Component,
        },
        mounted() {
            this._getTipsInfo();
            if (this.isTokenExist()) {
                this.redisKey = this.$route.query.redisKey;
                // this.facilityCode = this.$route.query.facilityCode;
                // this.productId = this.$route.query.productId;
                // this.commodityCode = this.$route.query.commodityCode;
                // this.amount = this.$route.query.amount;
                // // this.qr_type = this.$route.query.qr_type;
                // this.order_no = this.$route.query.order_no;
                this.$api.getQrCodeInfoByRedisKey(this.redisKey).then((res) => {
                    if (!res || !res.orderInfo || !res.orderInfo.productId) {
                        localStorage.clear();
                        location.href = `http://www.xincoffee.net/coffee/wechat/user/auth_union?redisKey=${this.redisKey}`;
                        return;
                    }
                    const result = res.orderInfo;
                    this.facilityCode = result.facilityCode;
                    this.productId = result.productId;
                    this.commodityCode = result.commodityCode;
                    this.amount = result.amount;
                    this.facilityId = result.facilityId;
                    // this.qr_type = this.$route.query.qr_type;
                    this.order_no = result.order_no;
                    this.auth = res.auth;
                    localStorage.setItem("auth", this.auth);
                    this.getProductInfo(this.productId, this.amount);
                });
            } else {
                let href = window.location.href;
                console.log(href);
                if (href.includes("net/?code")) {
                    //url包括 com/?code 证明为从微信跳转回来的
                    if (href.includes("#/?redisKey")) {
                        href = href.replace("#/?redisKey", "&redisKey");
                    }
                    let url = href; //vue自动在末尾加了 #/ 符号，截取去掉
                    let jingPosit = url.indexOf("net/") + 4; //获取域名结束的位置
                    let urlLeft = url.substring(0, jingPosit); //url左侧部分
                    let urlRight = url.substring(jingPosit, url.length); //url右侧部分
                    window.location = urlLeft + "#/" + urlRight; //拼接跳转
                    return;
                }
                this.code = this.$route.query.code;
                this.redisKey = this.$route.query.redisKey;
                console.log(this.code && this.redisKey && !this.isTokenExist());
                if (this.code && this.redisKey && !this.isTokenExist()) {
                    this._checkCode(this.code, this.redisKey);
                } else {
                    if (!this.isTokenExist()) {
                        this.redisKey = this.$route.query.redisKey;
                        location.href = `http://www.xincoffee.net/coffee/wechat/user/auth?redisKey=${this.redisKey}`;
                    }
                }
            }
        },
        methods: {
            onOrderInvalid() {
                Dialog.alert({
                    title: "订单超期提醒",
                    message: "由于您未在预定时间内完成支付，订单已经取消，请重新扫码支付。",
                }).then(() => {
                    setTimeout('WeixinJSBridge.call("closeWindow")', 1500);
                });
            },
            _getTipsInfo() {
                this.$api.wechatTips().then((res) => {
                    const tipsValue = res.tipsValue;
                    const discountValue = res.discountValue;
                    if (tipsValue) {
                        this.tipsValue = tipsValue;
                    }
                    if (discountValue) {
                        this.discountValue = discountValue;
                    }
                });
            },
            _checkCode: function (code, redisKey) {
                this.$api.loginByCode(code, redisKey).then((res) => {
                    console.log(res);
                    if (res.code === 0) {
                        const token = res.token;
                        const orderInfo = res.orderInfo;
                        const auth = res.auth;
                        localStorage.setItem("token", token);
                        localStorage.setItem("auth", auth);
                        this.orderInfo = orderInfo;
                        this.auth = auth;
                        this._getOrderInfo(this.orderInfo);
                    }
                });
            },
            _getOrderInfo(orderInfo) {
                this.facilityId = orderInfo.facilityId;
                this.facilityCode = orderInfo.facilityCode;
                this.productId = orderInfo.productId;
                this.commodityCode = orderInfo.commodityCode;
                this.amount = orderInfo.amount;
                // this.qr_type = this.$route.query.qr_type;
                this.order_no = orderInfo.order_no;
                this.getProductInfo(this.productId, this.amount);
            },
            // //选中了优惠券之后执行计算操作
            onUserCoupon: function (couponInfo) {
                // console.log(couponInfo);
                var that = this;
                var orderInfo = that.order;
                console.log(orderInfo);
                var orderNew = couponModel.parseCoupon(couponInfo, orderInfo, true);
                // console.log(orderNewNew);
                // order: orderNew,
                if (orderNew.payAmount <= 0) {
                    orderNew["payAmount"] = 1; //不存在0元的支付场景,出现则所有产品实际支付金额变为0
                    console.log(orderNew);
                    for (let i = 0; i < orderNew.orderDetailDOS.length; i++) {
                        if (orderNew.orderDetailDOS[i].payAmount <= 0) {
                            orderNew.orderDetailDOS[i].payAmount = 0;
                        }
                    }
                }
                this.orderWithCoupon = orderNew;
                this.payAmount = (orderNew["payAmount"] / 100).toFixed(2) * 100;
                this.saleAmount = (orderNew["saleAmount"] / 100).toFixed(2) * 100;
                this.showCouponList = false;
                this.couponPrice = '-￥' + this.saleAmount / 100;
            },
            onShowCouponClick() {
                if (this.auth) {
                    this.showCouponList = true;
                    return;
                }
                localStorage.removeItem("token");
                localStorage.removeItem("auth");
                location.href = `http://www.xincoffee.net/coffee/wechat/user/auth_union?redisKey=${this.redisKey}`;
            },
            showCouponIntroduction(index, list) {
                for (let i = 0; i < list.length; i++) {
                    if (i !== index) {
                        let item = list[i];
                        item["showIntroduction"] = false;
                    }
                }
                console.log(list);
                list[index]["showIntroduction"] = !list[index]["showIntroduction"];
                this.$set(list, index, list[index]);
            },
            onSubmit: function () {
            },
            _getPayAmount(dealAmount, couponAmount) {
                return dealAmount - couponAmount;
            },
            getProductInfo(productId, amount) {
                this.$api.getProductInfo(productId).then((res) => {
                    this.productInfo = res.data[0];
                    // console.log(this.productInfo);
                    // console.log(res);
                    let orderDetail = [];
                    let order = {};
                    //用于支付的order拼装
                    order["dealAmount"] = amount;
                    order["payAmount"] = this._getPayAmount(
                        order.dealAmount,
                        this.couponAmount
                    );
                    order["remark"] = this.productInfo.productName;
                    order["facilityId"] = this.facilityId;
                    order["facilityCode"] = this.facilityCode;
                    order["orderLable"] = "设备";
                    let orderItem = {};
                    orderItem["commodityId"] = productId;
                    orderItem["commodityName"] = this.productInfo.productName;
                    orderItem["commodityCode"] = this.commodityCode;
                    orderItem["amount"] = 1;
                    orderItem["commodityFastCode"] = 111; //不需要浓度 传固定无用的数据
                    orderItem["payAmount"] = amount;
                    orderItem["barcodeOrderNo"] = this.order_no;
                    orderItem["facilityId"] = this.facilityId;
                    orderDetail.push(orderItem);
                    order["orderDetailDOS"] = orderDetail;
                    this.order = order;
                    this._prePay(order);
                });
            },
            getContent(type, money) {
                let moneyActual = money / 100;

                if (type == 2 || type == 4) {
                    return moneyActual / 10;
                } else {
                    return moneyActual;
                }
            },
            getContentTxt(type) {
                //   var moneyActual = money / 100;

                if (type == 2 || type == 4) {
                    return "折";
                } else {
                    return "元";
                }
            },
            getCouponType(couponInfo) {
                var couponType = couponInfo.couponType;
                if (couponType == 3) {
                    return "设备券";
                } else {
                    if (
                        couponType == 5 &&
                        couponInfo.facilityId == ",," &&
                        couponInfo.productId == ",,"
                    ) {
                        return "无效券";
                    }
                    if (couponInfo.facilityId != ",,") {
                        return "设备券";
                    }
                    return "通用券";
                }
            },
            onDisabledCoupon () {
                this.showCouponList = false;
                this.couponPrice = null;
            },
            //页面加载时调用 请求后台获取支付的订单等信息
            _prePay(order) {
                this.$api.prePay(order).then((res) => {
                    this.couponListCanUse = res.data.canUse;
                    this.couponListNoUse = res.data.noUse;
                });
            },
            //点击支付按钮
            onPay: function () {
                // wx.showLoading({
                //     title: '正在请求支付',
                // });
                let order = {};
                if (!this.orderWithCoupon) {
                    order = this.order;
                } else {
                    order = this.orderWithCoupon;
                }
                if (order.payAmount <= 0) {
                    order.payAmount === 1; //不存在0元的支付场景
                }
                this.$api.submitOrder(order).then((resServer) => {
                    // wx.hideLoading();
                    // const orderId = resServer.orderId;
                    const payParams = resServer.data;
                    // eslint-disable-next-line no-undef
                    WeixinJSBridge.invoke("getBrandWCPayRequest", payParams, (res) => {
                        if (res.err_msg === "get_brand_wcpay_request:ok") {
                            // 使用以上方式判断前端返回,微信团队郑重提示：
                            // res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
                            setTimeout('WeixinJSBridge.call("closeWindow")', 1500);
                        }
                    });
                });
                // payModel.doPay().then((res));
            },
        },
    };
</script>

<style scoped>
    .order-container {
        background: #f7f8fa;
        position: fixed;
        /* width: 100%; */
        height: 100%;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        padding-top: 20px;
        padding-right: 20px;
        padding-left: 20px;
    }

    .total-value {
        text-align: right;
        font-weight: bold;
        font-size: 17px;
    }

    .item-value {
        text-align: right;
        font-weight: bold;
        font-size: 15px;
    }

    .line_vertical {
        background-color: #fff;
        height: 50px;
        width: 20px;
    }

    .coupon-item {
        /* height: 100%; */
        /* border: 2px #7ca7d2 solid; */
        /* width: 60%; */
        display: flex;
        flex-direction: column;
        background-color: white;
        margin-top: 10px;
        border-radius: 10px;
        /* margin: 20px auto; */
        padding: 10px 0;
        /* align-items: center; */
    }

    .coupon-item .left-container {
        width: 80px;
        height: 80px;
        display: flex;
        margin-left: 10px;
        /* margin-right: 10px; */
        text-align: center;
        align-items: center;
        justify-content: center;
        background: #ffc204;
        border-radius: 15px;
        color: #fff;
        position: relative;
        font-size: 22px;
        flex-shrink: 0;
    }

    .title-container {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: flex-start;
    }

    .coupon-item .left-container .left-unit {
        position: absolute;
        bottom: 10px;
        right: 10px;
        font-size: 14px;
    }

    .coupon-type {
        font-size: 15px;
        color: white;
        margin-right: 5px;
        font-weight: bold;
    }

    .coupon-item .right-container {
        width: 100%;
        height: 80px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        position: relative;
        background-color: #ffc204;
        border-radius: 10px;
        padding: 0 10px 0 15px;
    }

    .tag-float {
        position: absolute;
        width: 70px;
        height: 25px;
        bottom: 0;
        right: 0;
        z-index: 99;
    }

    .coupon-item .right-container .title {
        font-size: 16px;
        line-height: 25px;
        font-weight: 400;
    }

    .coupon-item .right-container .sub-title {
        font-size: 14px;
        color: grey;
        margin-top: 5px;
    }

    .coupon-item .right-container .data {
        font-size: 10px;
        color: grey;
        margin-top: 5px;
    }

    .main-container {
        display: flex;
        flex-direction: row;
        height: 80px;
        width: 95%;
        background-color: white;
        align-items: center;
        position: relative;
        /* margin: 0 auto; */
        /* border: 1rpx #7ca7d2 solid; */
    }

    .introduction-tag {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        font-size: 10px;
        /* width: 100%; */
        padding-left: 25px;
        padding-top: 20px;
        color: gray;
    }

    .introduction-tag img {
        width: 10px;
        height: 10px;
        margin-left: 5px;
    }

    .introduction-content {
        width: 60%;
        margin: 0 auto;
        color: gray;
        font-size: 13px;
        padding: 5px;
        text-align: left;
    }

    .coupon-popup-container {
        position: relative;
        padding-bottom: 70px;
    }

    .coupon-btn-container {
        padding: 10px 0px;
        align-items: center;
        justify-content: center;
        position: fixed;
        bottom: 0;
        left: 0;
        width: 100%;
        background: #fff;
        /*right: 0;*/
    }

    .coupon-list-container {
        padding: 10px;
    }

    .van-cell-group {
        border-radius: 10px;
        overflow: hidden;
    }

    .van-cell-group__title {
        font-size: 26px;
        text-align: center;
        margin-top: 10px;
        margin-bottom: 20px;
    }

    .van-submit-bar__bar {
        width: 100%;
        height: 70px;
    }

    .dk-flex-row-center {
        color: #333;
    }

    .van-submit-bar__button {
        margin-right: 30px;
    }

    /* 使用说明三角 */
    .boxtop {
        width: 0;
        border-top: 5px solid gray;
        border-right: 5px solid transparent;
        border-bottom: 5px solid transparent;
        border-left: 5px solid transparent;
        margin-left: 5px;
        position: relative;
        top: 5px;
    }

    .boxbottom {
        width: 0;
        border-top: 5px solid transparent;
        border-right: 5px solid transparent;
        border-bottom: 5px solid gray;
        border-left: 5px solid transparent;
        margin-left: 5px;
        position: relative;
        bottom: 5px;
    }
</style>
